import React from "react";
import { TrendingUp, Ticket, ArrowUpRight } from "lucide-react";
import { adminStats } from "../mock";
import useReveal from "../hooks/useReveal";

export default function AdminTools({ content = {} }) {
  const { ref, cls } = useReveal();
  return (
    <section className="bg-[#f6f8fb] py-24">
      <div ref={ref} className={`max-w-[1180px] mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center ${cls}`}>
        {/* Dashboard mockup */}
        <div className="relative">
          <div className="bg-white rounded-2xl shadow-[0_25px_70px_rgba(20,30,55,0.15)] p-6">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[#2ec9c9] flex items-center justify-center text-white font-semibold">A</div>
                <div>
                  <p className="text-[#16243b] font-semibold text-[0.95rem] leading-tight">Allan</p>
                  <p className="text-[#8a97a8] text-[0.75rem]">Store manager</p>
                </div>
              </div>
              <button className="gp-btn-teal rounded-full px-4 py-2 text-[0.8rem] font-medium flex items-center gap-1">
                <Ticket size={15} /> Redeem voucher
              </button>
            </div>

            <div className="grid grid-cols-3 gap-3 mb-6">
              {adminStats.map((s) => (
                <div key={s.label} className="bg-[#f6f8fb] rounded-xl p-4">
                  <p className="text-[#8a97a8] text-[0.72rem] mb-1">{s.label}</p>
                  <p className="text-[#16243b] font-bold text-[1.05rem] leading-tight">{s.value}</p>
                </div>
              ))}
            </div>

            <div className="bg-[#f6f8fb] rounded-xl p-5">
              <div className="flex items-center justify-between mb-4">
                <p className="text-[#16243b] font-semibold text-[0.9rem] flex items-center gap-2">
                  <TrendingUp size={16} className="text-[#2ec9c9]" /> Sales over time
                </p>
                <span className="text-[#2ec9c9] text-[0.78rem] font-medium flex items-center">+24% <ArrowUpRight size={14} /></span>
              </div>
              <svg viewBox="0 0 300 90" className="w-full h-24">
                <polyline
                  fill="none" stroke="#2ec9c9" strokeWidth="3" strokeLinecap="round"
                  points="0,70 40,58 80,64 120,40 160,46 200,26 240,32 300,12"
                />
                <polygon fill="rgba(46,201,201,0.12)" points="0,70 40,58 80,64 120,40 160,46 200,26 240,32 300,12 300,90 0,90" />
              </svg>
            </div>
          </div>
        </div>

        {/* Text + testimonial */}
        <div>
          <h2 className="gp-heading text-[2.3rem] sm:text-[2.7rem]">{content.admin_title || "Tools to grow your voucher revenue"}</h2>
          <p className="text-[#5a6b80] text-[1.12rem] leading-relaxed mt-5 max-w-[480px]">
            {content.admin_text || "When it comes to scaling your gift voucher revenue we include the most comprehensive suite of tools available."}
          </p>
          <a href="#features" className="gp-btn-outline inline-block rounded-full px-8 py-3 font-medium mt-8">
            {content.admin_cta || "About the admin area"}
          </a>

          <div className="mt-10 bg-white rounded-2xl p-6 shadow-[0_15px_40px_rgba(20,30,55,0.08)] border border-gray-100">
            <p className="text-[#1c2b40] text-[1.02rem] leading-relaxed italic">“{content.admin_quote || "We were delighted with the level of service and care."}”</p>
            <div className="flex items-center gap-3 mt-5">
              {content.admin_quote_avatar && <img src={content.admin_quote_avatar} alt={content.admin_quote_name} className="w-11 h-11 rounded-full object-cover" />}
              <div>
                <p className="text-[#16243b] font-semibold text-[0.92rem] leading-tight">{content.admin_quote_name || ""}</p>
                <p className="text-[#8a97a8] text-[0.8rem]">{content.admin_quote_role || ""}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
